/**
 * Force download of Blob in browser by faking an <a> tag.
 *
 * @param {Blob} blob - Base64 URL.
 * @param {string} fileName - The filename to appear in the download dialog.
 * @returns {void}
 */
export function downloadBlob(blob, fileName = 'recording.ogg') {
    const base64Url = window.URL.createObjectURL(blob);

    // fake a anchor tag
    const a = document.createElement('a');

    a.style = 'display: none';
    a.href = base64Url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // An object URL is a strong reference to the blob: until it is revoked the whole recording stays in memory,
    // for the lifetime of the document. Revoking synchronously can cancel the download in some browsers, so give
    // the click a turn of the event loop first.
    setTimeout(() => window.URL.revokeObjectURL(base64Url), 0);
}
